import { createExpandElement } from '../../../body-cells-frozen/create-expand-element';
import { createCollapseElement } from '../../../body-cells-frozen/create-collapse-element';
import { TTableItem } from '../../../../custom-table/table.model';

export function getArrowElement(groupsCollapsed: Set<string>, item: TTableItem): HTMLElement {
  let arrowElement = null;

  if (groupsCollapsed.has(item.id)) {
    arrowElement = createExpandElement(item);
  } else {
    arrowElement = createCollapseElement(item);
  }
  return arrowElement;
}
